import React, { Component } from 'react'
import { Route, Link } from 'react-router-dom'
import { Breadcrumb, Button, Icon } from 'antd'
import '../assets/css/achieveAboard.css'
import AchieveAboardForm from '../components/AchieveAboardForm'
import AchieveList from './AchieveList'

class AchieveAboard extends Component {

    handleHistoryBack = () => {
        this.props.history.go(-1)
    }

    // 进入列表页
    handleSearch = () => {
        this.props.history.push('/achieveAboard/list')
    }

    render() {
        const { match } = this.props
        return (
            <div>
                <div className="banner-item banner-achieve">
                    <div className="l-container">
                        <h2>业绩看板</h2>
                    </div>
                </div>
                <div className="page-title l-container achieve-title">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item><a href="/gs/">首页</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/gs/business/">我们的业务</a></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/">资产托管与基金服务</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/achieveAboard">业绩看板</Link></Breadcrumb.Item>
                    </Breadcrumb>
                    {
                        !match.isExact && <div style={{lineHeight: '64px'}}><Button type="link" style={{color: '#0D5FE0'}} onClick={this.handleHistoryBack}><Icon type="left"/>返回</Button></div>
                    }
                </div>
                {   match.isExact &&
                    <div className="page-content-achieve l-container">
                        <div>
                            <h6>特别提示</h6>
                            <p>
                                中国证券投资基金业协会颁布的《私募投资基金信息披露管理办法》第十一条规定：“信息披露义务人披露基金信息，不得存在以下行为： （一）公开披露或者变相公开披露”。为符合前述法规要求，托管人官网将只对特定投资者提供私募基金净值信息。 请投资者联系管理人获取密码，进行私募基金净值的查询
                            </p>
                        </div>
                        <div>
                            <AchieveAboardForm handleSearch={this.handleSearch}></AchieveAboardForm>
                        </div>
                    </div>
                }
                <Route path={`${match.url}/list`} component={ AchieveList }/>
            </div>
        )
    }
}

export default AchieveAboard
